import { render, staticRenderFns } from "./foot.vue?vue&type=template&id=4d787e5c&scoped=true"
import script from "./foot.vue?vue&type=script&lang=js"
export * from "./foot.vue?vue&type=script&lang=js"
import style0 from "./foot.vue?vue&type=style&index=0&id=4d787e5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d787e5c",
  null
  
)

export default component.exports